const validaCCC = (val) => {

    let banco = val.substring(0,4)
    let sucursal = val.substring(4,8)
    let dc = val.substring(8,10)
    let cuenta=val.substring(10,20)
    
    if (!/^[0-9]{20}$/.test(banco + sucursal + dc + cuenta)){
        return false
    } else {
        const valores = new Array(1, 2, 4, 8, 5, 10, 9, 7, 3, 6)
        
        let control = 0
        for (let i = 0; i <= 9; i++) {
            control += parseInt(cuenta.charAt(i)) * valores[i]
        }    
        control = 11 - (control % 11)
        
        if (control == 11) {
            control = 0
        } else if (control == 10) {
            control = 1
        } 

        if(control != parseInt(dc.charAt(1))) {
            return false;
        }

        control = 0;
        let zbs = "00" + banco + sucursal
        for (let i = 0; i <= 9; i++) {
            control += parseInt(zbs.charAt(i)) * valores[i]
        }
            
        control = 11 - (control % 11)
        
        if (control == 11) {
            control = 0
        } else if (control == 10) {
            control = 1
        }
            
        if(control != parseInt(dc.charAt(0))) {
            return false
        }

        return true
    }

}

export default validaCCC